import { dateRangeFilterOptions, labelsAppearance } from "../../consts";

const dateRangeConfig = [
  {
    id: dateRangeFilterOptions.TODAY,
    config: {
      formatFn: "formatHour",
      dateListGetter: "getHoursList",
      appearance: labelsAppearance.ANGLED
    }
  },
  {
    id: dateRangeFilterOptions.LAST_24_HOURS,
    config: {
      formatFn: "formatHour",
      dateListGetter: "getHoursList",
      appearance: labelsAppearance.ANGLED
    }
  },
  {
    id: dateRangeFilterOptions.LAST_7_DAYS,
    config: {
      formatFn: "formatDay",
      dateListGetter: "getDatesList",
      appearance: labelsAppearance.HORIZONTAL
    }
  },
  {
    id: dateRangeFilterOptions.LAST_30_DAYS,
    config: {
      formatFn: "formatMonthDay",
      dateListGetter: "getDatesList",
      appearance: labelsAppearance.VERTICAL
    }
  },
  {
    id: dateRangeFilterOptions.LAST_12_MONTHS,
    config: {
      formatFn: "formatMonthName",
      dateListGetter: "getMonthsList",
      appearance: labelsAppearance.ANGLED
    }
  }
];

export default dateRangeConfig;
